import React, { ReactNode } from 'react';
import styled from 'styled-components';

import ClickOutside from '../ClickOutside';

interface Props {
  onClose: () => void;
  open: boolean;
  children: ReactNode;
  modalEdit: boolean;
  canClickOutside?: boolean;
}

export default function BasicModal({ onClose, open, children, modalEdit, canClickOutside = true }: Props) {
  if (!open) {
    return null;
  }

  let body = <CustomModalEdit modalEdit={modalEdit}>
    <div className="position-relative">
      {children}
    </div>
  </CustomModalEdit>;

  if (canClickOutside) {
    body = <ClickOutside onClickOutside={onClose} otherInsides={['.pac-container', '.popover']}>
      {body}
    </ClickOutside>;
  }

  return (
    <CustomBackdrop>
      {body}
    </CustomBackdrop>
  );

}

const CustomBackdrop = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(1, 1, 1, 0.2);
  z-index: 971;
  overflow-x: hidden;
  overflow-y: auto;
`;

const CustomModalEdit = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 1.75rem auto;
  background: #fff;
  border-radius: 4px;
  filter: blur(0);
  transform: scale(1);
  z-index: 975;
  padding: 24px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  max-width: ${(props: { modalEdit: boolean }) => props.modalEdit ? '600px' : '700px'};
`;
